module.exports = __webpack_public_path__ + "static/0033-d36fb5566531663e01e2bc0e733431dd.png";